import { useEffect, useRef } from "react";
import styles from "../../../styles/CardOption.module.css";
import OptimizedImage from "../../../components/OptimizedImage";

const hexToRgba = (hex, alpha = 1) => {
    if (!hex) return `rgba(52, 140, 158, ${alpha})`;
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) return `rgba(52, 140, 158, ${alpha})`;
    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const CardOption = ({ label, selected, onClick, imageUrl, customStyles = {}, theme = {} }) => {
    const cardRef = useRef(null);
    const cardTopBarColor = theme.cardHoverBorderColor || theme.buttonColor || "#348C9E";
    const cardTopBarColorRgba30 = hexToRgba(cardTopBarColor, 0.3);
    const cardTopBarColorRgba60 = hexToRgba(cardTopBarColor, 0.6);
    
    // Clear inline border styles when selection changes
    useEffect(() => {
        if (cardRef.current && !selected) {
            // Clear any inline border color styles when card becomes unselected
            // This ensures the CSS classes control the styling, not leftover inline styles
            cardRef.current.style.borderColor = "";
        }
    }, [selected]);
    
    return (
    <div
        ref={cardRef}
        onClick={onClick}
        className={`${styles.card} ${selected ? styles.cardSelected : ""} ${!imageUrl ? styles.cardNoImage : ""}`}
        style={{
            ...customStyles.card,
            '--card-top-bar-color-30': cardTopBarColorRgba30,
            '--card-top-bar-color-60': cardTopBarColorRgba60,
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") onClick();
        }}
        aria-pressed={selected}
        onMouseEnter={(e) => {
            if (!selected && theme.cardHoverBorderColor) {
                e.currentTarget.style.borderColor = theme.cardHoverBorderColor;
            }
        }}
        onMouseLeave={(e) => {
            if (!selected) {
                // Clear inline border color to let CSS handle it
                e.currentTarget.style.borderColor = "";
            }
        }}
    >
        {imageUrl && (
            <OptimizedImage
                src={imageUrl}
                alt={label}
                className={styles.cardImage}
                style={customStyles.cardImage}
                lazy={true}
                objectFit="contain"
            />
        )}
        <div
            className={styles.cardLabel}
            style={customStyles.cardLabel}
        >
            {label}
        </div>
    </div>
    );
};

export default CardOption;
